import { useCustomerId } from '../../authentication/hooks/user';
import { Customer } from './sidecar.types';
import { useSidecarFile } from './sidecar';

interface CustomerState {
  customer: Customer;
  directoryId: string;
}

export const useCustomerDetails = (id: string) => {
  const details = useSidecarFile<Customer>(`${id}:/Customer.sidecar`);
  if (!details || !details[0]) {
    throw Error("Could not get customer details");
  }

  return details[0];
};

export const useCustomer = () => {
  const customerId = useCustomerId();
  return useCustomerDetails(customerId);
};
